import React, { FC } from 'react';
import styled from 'styled-components';
import { Content } from '@vodafoneis/sjonvarpskjarni-js-lib';
import { useContentRating } from '../../hooks/useContentRating';

const ContentRatingContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	height: 24px;

	img {
		height: 24px;
		background-color: white;
		border-radius: 50%;
		border: 1px solid white;
	}
`;

type Props = {
	content: Content;
	fallbackAgeRating?: number;
};

export const HeroContentRating: FC<Props> = ({ content, fallbackAgeRating }) => {
	const idToFetch = content?.id || null;
	const { contentRating: fetchedRating } = useContentRating(idToFetch);

	// Try to get rating from various sources
	const rating = (content as any)?.contentRating || (content as any)?._raw?.contentRating || fetchedRating;

	if (rating) {
		return (
			<ContentRatingContainer>
				{rating.icon && <img src={rating.icon} alt={rating.name || ''} title={rating.name || ''} />}
				{rating.contentFlags
					?.slice()
					.sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
					.slice(0, 3)
					.map((flag: any) => flag.icon && <img key={flag.identifier} src={flag.icon} alt={flag.name || ''} title={flag.name || ''} />)}
			</ContentRatingContainer>
		);
	}

	// Fallback to old age rating display if no content rating is available
	if (fallbackAgeRating !== undefined && fallbackAgeRating !== null) {
		return (
			<ContentRatingContainer>
				<div
					style={{
						width: '24px',
						height: '24px',
						backgroundSize: '24px 24px',
						backgroundRepeat: 'no-repeat',
						backgroundImage: `url('/images/${fallbackAgeRating}@1.5x.png')`,
					}}
				/>
			</ContentRatingContainer>
		);
	}

	return null;
};
